/* ARMORA - scroll reveal.

   Tags content automatically rather than asking every section to opt in, so
   the Dawn sections (rich text, FAQ, before/after, contact form, grids) get
   the same motion as the new ones without touching their markup.

   Rules of the road:
   - the header, announcement bar, hero and promo popup are never touched;
   - nothing inside the product buy-box or gallery is touched, because that
     column is sticky and animating it fights the scroll;
   - elements that already carry .reveal keep au-ui.js as their observer;
   - one IntersectionObserver for the whole page, and each element is
     unobserved the moment it has played;
   - a safety pass reveals anything still hidden after 2.5s, so a missed
     observer callback can never leave content invisible. */
(function () {
  'use strict';

  var GROUP = [
    '.pcard',
    '.cat-card',
    '.gal__slide',
    '.au-trust__item',
    '.icon-cols > *',
    '.discover__fact',
    '.article-card',
    '.article-row',
    '.au-logos__item',
    '.au-footer__col',
    '.product-grid > .grid__item'
  ].join(',');

  var HEAD = '.au-section__head, .title-wrapper, .collection-hero__inner, .rich-text__wrapper, .collapsible-content__wrapper';
  var MEDIA = '.media-banner, .banner__media';
  var INNER = '.au-width, .page-width, .container, .rich-text__wrapper';

  var SKIP = /(__header|__announcement|au_announcement|au_hero|promo-popup|popup|__footer-group)/i;

  var STAGGER = 75;
  var MAX_STEPS = 8;

  var io = null;
  var watched = [];

  function show(el) {
    el.classList.add('au-in');
    if (io) io.unobserve(el);
  }

  function makeObserver() {
    if (!('IntersectionObserver' in window)) return null;
    return new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) show(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
  }

  function usable(el) {
    if (!el || el.hasAttribute('data-au-rv')) return false;
    if (el.classList.contains('reveal')) return false;
    if (el.closest('.product__info-container')) return false;
    if (el.closest('.product__media-wrapper')) return false;
    if (el.closest('.section-header')) return false;
    if (el.closest('[data-au-rv]')) return false;
    return true;
  }

  function mark(el, kind, delay) {
    if (!usable(el)) return false;
    el.setAttribute('data-au-rv', kind);
    if (delay) el.style.setProperty('--au-rv-delay', delay + 'ms');
    if (io) { io.observe(el); watched.push(el); } else { show(el); }
    return true;
  }

  function scan(root) {
    var sections = (root || document).querySelectorAll('.shopify-section');

    Array.prototype.forEach.call(sections, function (sec) {
      if (SKIP.test(sec.id || '')) return;
      if (sec.offsetHeight === 0) return;

      var marked = false;

      var head = sec.querySelector(HEAD);
      if (head && mark(head, 'head', 0)) marked = true;

      var media = sec.querySelector(MEDIA);
      if (media && mark(media, 'media', 0)) marked = true;

      var items = sec.querySelectorAll(GROUP);
      if (items.length) {
        Array.prototype.forEach.call(items, function (el, i) {
          var step = Math.min(i, MAX_STEPS);
          if (mark(el, 'item', 120 + step * STAGGER)) marked = true;
        });
      }

      if (!marked) {
        mark(sec.querySelector(INNER) || sec.firstElementChild, 'block', 0);
      }
    });

    safetyNet();
  }

  /* If anything is still hidden while sitting inside the viewport after the
     page has settled, show it. Content is never allowed to stay invisible
     because of a missed callback. */
  var safetyTimer = null;
  function safetyNet() {
    clearTimeout(safetyTimer);
    safetyTimer = setTimeout(function () {
      watched.forEach(function (el) {
        if (el.classList.contains('au-in')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) show(el);
      });
    }, 2500);
  }

  function boot() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!io) io = makeObserver();
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(); scan(e.target); });
  document.addEventListener('shopify:section:reorder', boot);

  window.addEventListener('popstate', function () { setTimeout(boot, 350); });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.facets, .facets-container, .pagination')) setTimeout(boot, 450);
  }, true);
})();
